export default __webpack_public_path__ + "static/media/3.08e45494.jpg";